var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"module register-box over"},[_c('div',{staticClass:"contents centered"},[_c('h2',{staticClass:"uppercase huge"},[_vm._v("Sei un musicista o un appassionato di musica?")]),_vm._v(" "),_c('router-link',{staticClass:"button button-big button-azure",attrs:{"to":"/signup"}},[_vm._v("Registrati per scaricare gratuitamente i nostri brani")])],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9679341a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/AlbumBanner.vue
// module id = 550
// module chunks = 0